import * as yup from 'yup'

const requiredMessage = 'This field is required.'

export interface IShipmentMotorCarrier {
  id: number
  name: string
  dotNumber?: string | number | null
  legalName?: string
  dbaName?: string | null
}

export const MotorCarrierSchema = yup.object<IShipmentMotorCarrier>({
  id: yup.number().required(requiredMessage),
  name: yup.string().required(requiredMessage),
  dotNumber: yup.mixed().nullable(),
  dbaName: yup.string().nullable(),
})
